<div soho-homepage soho-homepage-sizer [columns]="columns" *ngIf="displayedOnPagePanel || fromDataView">
  <ng-container *ngFor="let panel of dashboardPanels" [ngSwitch]="panel.type">
      <lm-dashboard-panel-list #dashboardPanel
        *ngSwitchCase="'list'"
        [panel]="panel"
        [fromDataView]="fromDataView"
        [messageRuleView]="messageRuleView"
        (componentDisplayed)="onComponentDisplayed()"
        (contentModified)="onContentModified($event)"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
        (panelTransactionEvent)="onPanelTransactionEvent($event)"
        (drillAroundEvent)="onDrillAroundEvent($event)"
      ></lm-dashboard-panel-list>

      <lm-dashboard-panel-list #dashboardPanel
        *ngSwitchCase="'formlist'"
        [panel]="panel"
        [fromDataView]="fromDataView"
        [messageRuleView]="messageRuleView"
        (componentDisplayed)="onComponentDisplayed()"
        (contentModified)="onContentModified($event)"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
        (panelTransactionEvent)="onPanelTransactionEvent($event)"
        (drillAroundEvent)="onDrillAroundEvent($event)"
       ></lm-dashboard-panel-list>

      <lm-dashboard-panel-form #dashboardPanel
        *ngSwitchCase="'standardform'"
        [panel]="panel"
        [formUrlInfo]="formUrlInfo"
        [fromDataView]="fromDataView"
        [messageRuleView]="messageRuleView"
        (componentDisplayed)="onComponentDisplayed()"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-dashboard-panel-form>

      <lm-dashboard-panel-form #dashboardPanel
        *ngSwitchCase="'form'"
        [panel]="panel"
        [formUrlInfo]="formUrlInfo"
        [fromDataView]="fromDataView"
        [messageRuleView]="messageRuleView"
        [model]="model"
        [placeHolder]="placeHolder"
        [specFields]="specFields"
        (componentDisplayed)="onComponentDisplayed()"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-dashboard-panel-form>

      <lm-dashboard-panel-form #dashboardPanel
         *ngSwitchCase="'independentform'"
         [panel]="panel"
         [fromDataView]="fromDataView"
         [messageRuleView]="messageRuleView"
         (componentDisplayed)="onComponentDisplayed()"
      ></lm-dashboard-panel-form>

      <lm-dashboard-panel-form-template #dashboardPanel
        *ngSwitchCase="'templateform'"
        [panel]="panel"
        [fromDataView]="fromDataView"
        [messageRuleView]="messageRuleView"
        [model]="model"
        [placeHolder]="placeHolder"
        [specFields]="specFields"
        (componentDisplayed)="onComponentDisplayed()"
      ></lm-dashboard-panel-form-template>

      <lm-dashboard-panel-form #dashboardPanel
        *ngSwitchCase="'instancecountchart'"
        [panel]="panel"
        [fromDataView]="fromDataView"
        [messageRuleView]="messageRuleView"
        (componentDisplayed)="onComponentDisplayed()"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-dashboard-panel-form>

      <lm-dashboard-panel-card
        *ngSwitchCase="'cardview'"
        [panel]="panel"
        [fromDataView]="fromDataView"
        [messageRuleView]="messageRuleView"
        (uiLinkEvent)="onUILinkEvent($event)"
        (componentDisplayed)="onComponentDisplayed()"
      ></lm-dashboard-panel-card>

      <lm-dashboard-panel-form
        *ngSwitchCase="'menuPanel'"
        [panel]="panel"
        [fromDataView]="messageRuleView"
        (componentDisplayed)="onComponentDisplayed()"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-dashboard-panel-form>

      <lm-dashboard-panel-url
          *ngSwitchCase="'url'"
          [panel]="panel"
          [fromDataView]="fromDataView"
          [messageRuleView]="messageRuleView"
          (uiLinkEvent)="onUILinkEvent($event)"
          (componentDisplayed)="onComponentDisplayed()"
      ></lm-dashboard-panel-url>

      <lm-dashboard-panel-url
          *ngSwitchCase="'link'"
          [panel]="panel"
          [fromDataView]="fromDataView"
          [messageRuleView]="messageRuleView"
          (uiLinkEvent)="onUILinkEvent($event)"
          (componentDisplayed)="onComponentDisplayed()"
      ></lm-dashboard-panel-url>

      <!-- future
      <lm-dashboard-panel-httpurl></lm-dashboard-panel-httpurl>
      -->
  </ng-container>
</div>
